import React from 'react'
import { Card, Row } from 'antd'
import Heading from '../../../component/common/Heading'
import CRUDComponent from '../../../component/common/CRUD-Component'
import CONSTANTS from '../../../util/constant/CONSTANTS'
import { useNavigate } from 'react-router-dom'

const DeviceType = () => {
    const navigate = useNavigate();
    return (
        <>
            <div>
                <Card className="my-5">
                    <Heading>Device Type</Heading>
                    <Row>
                        <CRUDComponent
                            GET={{
                                API: CONSTANTS.API.DeviceType.getAll,
                                DataModifier: (res, API, Setrefresh) => {
                                    // console.log(res, "GET ALL ABCD");
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `DT${data?.id.toString().padStart(7, "0")}`,

                                            view: {
                                                id: data?.id,
                                                onClick: () => {
                                                    const type = data?.type === 'Type 1' ? 'type-1' : 'type-2'
                                                    navigate(`/app/device/${type}`)
                                                }
                                            }
                                        }
                                    })
                                },
                                column: CONSTANTS.TABLE.DEVICETYPE,
                            }}

                        />
                    </Row>
                </Card>
            </div>
        </>
    )
}

export default DeviceType